import { Outlet } from "react-router";

const Exams = () => {
  return <Outlet />;
};

export default Exams;
